import React from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const SaveChangesButton = () => {
  return (
    <Row>
      <Col lg={3} xs={12}>
        <div className="form-group">
          <button type="submit" className="btn btn-blue">
            <FormattedMessage id={"saveChanges"} />
          </button>
        </div>
      </Col>
    </Row>
  );
};

export default SaveChangesButton;
